__turbopack_context__.v({
  "color-accent": "IconButton-module-scss-module__vkTLnG__color-accent",
  "color-error": "IconButton-module-scss-module__vkTLnG__color-error",
  "color-primary": "IconButton-module-scss-module__vkTLnG__color-primary",
  "color-soft": "IconButton-module-scss-module__vkTLnG__color-soft",
  "icon-button": "IconButton-module-scss-module__vkTLnG__icon-button",
  "rounded": "IconButton-module-scss-module__vkTLnG__rounded",
  "selected": "IconButton-module-scss-module__vkTLnG__selected",
  "size-lg": "IconButton-module-scss-module__vkTLnG__size-lg",
  "size-md": "IconButton-module-scss-module__vkTLnG__size-md",
  "size-sm": "IconButton-module-scss-module__vkTLnG__size-sm",
  "variant-fill": "IconButton-module-scss-module__vkTLnG__variant-fill",
  "variant-ghost": "IconButton-module-scss-module__vkTLnG__variant-ghost",
  "variant-outlined": "IconButton-module-scss-module__vkTLnG__variant-outlined",
  "variant-overlay": "IconButton-module-scss-module__vkTLnG__variant-overlay",
});
